import { HTTP_INTERCEPTORS, provideHttpClient, withXsrfConfiguration } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { MzicHttpInterceptorInterceptor } from '@mzic/http-interceptor';
import { appRoutes } from './app.routes';
import { TranslocoRootModule } from './transloco-root.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    importProvidersFrom(TranslocoRootModule),
    provideHttpClient(
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      })
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MzicHttpInterceptorInterceptor,
      multi: true,
    },
  ],
};
